module.exports = __webpack_public_path__ + "static/media/icon-collection-solid-red.16736f50.svg";